// extracted by mini-css-extract-plugin
module.exports = {"box":"box-3y0ZMGe3 clearfix"};